import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const HomePage = ({ openLightbox }) => {
  const facilityImages = [
    { src: '/images/headquarters-denu.jpg', alt: 'Denu Headquarters', caption: 'Denu Headquarters • Main Office • Near St. Paul\'s Senior High School' },
    { src: '/images/community-center.jpg', alt: 'Community Center', caption: 'Volta Region Community & Support Center' },
    { src: '/images/agent-office.jpg', alt: 'Director\'s Office', caption: 'Gbozume • Nogokpo Near the toll booth' }
  ];

  const stats = [
    { value: '50+', label: 'Agents Nationwide' },
    { value: 'GH₵ 10M+', label: 'Prize Payouts' },
    { value: '100%', label: 'Transparent Draws' },
    { value: '24/7', label: 'Customer Support' }
  ];

  return (
    <div className="container fade-in-up">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-text">
          <div className="hero-badge">
            <i className="fas fa-certificate"></i> No Joke Lottery Company-NLA Partner
          </div>
          
          {/* Clean header - single line, no weird spacing */}
          {/* <h1 className="hero-title">Welcome to <span className="gold-text">No Joke Lotteries</span></h1> */}
          
          <p className="hero-description">No Joke Lottery is an official partner of the National Lottery Authority (NLA), Ghana. We are building a transparent, fair, and community-driven lottery experience across Ghana and beyond. We are committed to integrity, innovation, and giving back to our communities.</p>
          
          <div className="cta-group">
            <Link to="/about" className="btn-primary">Our Mission →</Link>
            <Link to="/support" className="btn-secondary">Get Support</Link>
          </div>
          
          {/* Trust Badges */}
          <div className="trust-badges">
            <div className="trust-badge">
              <i className="fas fa-shield-alt"></i>
              <span>100% Secure</span>
            </div>
            <div className="trust-badge">
              <i className="fas fa-chart-line"></i>
              <span>Instant Payouts</span>
            </div>
            <div className="trust-badge">
              <i className="fas fa-users"></i>
              <span>50k+ Happy Players</span>
            </div>
          </div>
        </div>
        
        <div className="hero-image">
          <div className="hero-image-wrapper">
            <img 
              src="/images/hero-lottery.png" 
              alt="I Don't Joke Lottery" 
              className="hero-img-real clickable"
              onClick={() => openLightbox('/images/hero-lottery.png', 'I Don\'t Joke Lottery - Your Trusted Lottery Partner')}
              onError={(e) => e.target.src = 'https://placehold.co/500x500/2a274d/FFD966?text=IDJ+LOTTERY'}
            />
            <div className="floating-card floating-card-1">
              <i className="fas fa-trophy"></i>
              <span>Big Wins</span>
            </div>
            <div className="floating-card floating-card-2">
              <i className="fas fa-clock"></i>
              <span>Daily Draws</span>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="stats-section">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Vision Section */}
      <div className="section-title">
        <span className="title-icon">✦</span>
        Why Choose Us
        <span className="title-icon">✦</span>
      </div>
      <div className="values-grid">
        <div className="value-card">
          <div className="card-icon-wrapper">
            <i className="fas fa-globe"></i>
          </div>
          <h3>National Expansion</h3>
          <p>By 2028, we aim to operate across all zones in Denu, Aflao, Dzodze, Abor and their surroundings with localized fair-play initiatives and community investment programs. Our headquarters is in Denu, Volta Region.</p>
          <Link to="/about" className="card-link">Learn more →</Link>
        </div>
        <div className="value-card featured">
          <div className="card-icon-wrapper">
            <i className="fas fa-chart-line"></i>
          </div>
          <h3>NLA Partnership</h3>
          <p>As an authorized partner of the National Lottery Authority (NLA), we ensure all draws are conducted with utmost transparency and regulatory compliance.</p>
          <Link to="/about" className="card-link">Learn more →</Link>
        </div>
        <div className="value-card">
          <div className="card-icon-wrapper">
            <i className="fas fa-hand-holding-heart"></i>
          </div>
          <h3>10% to Charity</h3>
          <p>Long-term commitment: 10% of all revenues fund education, healthcare, and local entrepreneurship programs across Ghanaian communities.</p>
          <Link to="/about" className="card-link">Learn more →</Link>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="section-title">
        <span className="title-icon">✦</span>
        How It Works
        <span className="title-icon">✦</span>
      </div>
      <div className="steps-grid">
        <div className="step-card">
          <div className="step-number">01</div>
          <div className="step-icon"><i className="fas fa-user-plus"></i></div>
          <h3>Plan and Prepare</h3>
          <p>Visit the office or call office partners</p>
        </div>
        <div className="step-card">
          <div className="step-number">02</div>
          <div className="step-icon"><i className="fas fa-ticket-alt"></i></div>
          <h3>Pick Your Numbers</h3>
          <p>Choose your lucky numbers or engage in quick forecast and planning</p>
        </div>
        <div className="step-card">
          <div className="step-number">03</div>
          <div className="step-icon"><i className="fas fa-chart-line"></i></div>
          <h3>Watch the Draw</h3>
          <p>Live draws with complete transparency on NLA partner platforms</p>
        </div>
        <div className="step-card">
          <div className="step-number">04</div>
          <div className="step-icon"><i className="fas fa-gem"></i></div>
          <h3>Claim Your Prize</h3>
          <p>Instant win checks and fast payouts</p>
        </div>
      </div>

      {/* CTA Banner */}
      <div className="cta-banner">
        <div className="cta-banner-content">
          <h3>Ready to Try Your Luck?</h3>
          <p>Join thousands of winners in the company today. Your winning moment awaits!</p>
          <Link to="/contact" className="btn-primary btn-large">
            Get Started Today <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
      </div>

      {/* Facilities Section */}
      <div className="section-title">
        <span className="title-icon">✦</span>
        Our Facilities
        <span className="title-icon">✦</span>
      </div>
      <div className="gallery-grid">
        {facilityImages.map((img, index) => (
          <div key={index} className="gallery-item">
            <img 
              src={img.src} 
              alt={img.alt} 
              className="real-img clickable"
              onClick={() => openLightbox(img.src, img.caption)}
              onError={(e) => e.target.src = `https://placehold.co/400x300/2a274d/FFD966?text=${img.alt}`}
            />
            <div className="caption">{img.caption}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePage;